import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreadcrumbComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  items: MenuItem[] = [];

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateBreadcrumbs();
      });

    this.updateBreadcrumbs();
  }

  private updateBreadcrumbs() {
    this.items = [];

    let currentRoute = this.activatedRoute.root;
    let url = '';

    while (currentRoute.children.length) {
      const childRoute = currentRoute.children[0];
      const routeConfig = childRoute.routeConfig;

      if (routeConfig?.data?.['breadcrumb']) {
        url += '/' + routeConfig.path;

        this.items.push({
          label: routeConfig.data['breadcrumb'],
          routerLink: url,
        });

        if (routeConfig.data['parent']) {
          const { label, route } = routeConfig.data['parent'];
          this.items.splice(this.items.length - 1, 0, {
            label,
            routerLink: route,
          });
        }
      }

      currentRoute = childRoute;
    }

    if (this.items.length > 0) {
      this.items[this.items.length - 1].routerLink = undefined;
    }
  }
}
